interface TreasuryBucketsConfig {
  [bucketName: string]: {
    fullName: string
    address: string
  }
}

export const treasuryBucketsConfig: TreasuryBucketsConfig = {
  genesisNftSeries1: {
    fullName: 'Genesis NFT Series 1',
    address: '0xC868485a916dFB23b1C4f5a77c9606A990FC742a',
  },
  genesisNftSeries2: {
    fullName: 'Genesis NFT Series 2',
    address: '0x7Cf35a1E310bf4F16729f10b60dcEbf0f3873556',
  },
  marketing: {
    fullName: 'Marketing',
    address: '0xbB8191257064d920b179CC29A94eAb2a8e43A225',
  },
  nftStakingRewards: {
    fullName: 'NFT Staking Rewards',
    address: '0xc6Fc9764F5800b9799088208eBA474075543CA8d',
  },
  publicSale: {
    fullName: 'Public Sale',
    address: '0x6D4b621c881BbD202bDFE968370c5C69769AD912',
  },
  team: {
    fullName: 'Team',
    address: '0xDb7D433A0d753370B9A012229e61b8329B2d9809',
  },
  treasury: {
    fullName: 'Treasury/Working capital',
    address: '0x69f6610b7F36763839f393392de74289AaC5f5DE',
  },
  rewards: {
    fullName: 'Rewards and incentives',
    address: '0x5ff5E95c857aC8726c1934Af550D57F64b09d9c7',
  },
  liquidity: {
    fullName: 'Exchanges and liquidity',
    address: '0xDCB6d4227A3b88c4310ce7e55e308b2dB4e46dD0',
  },
  community: {
    fullName: 'Community fund bootstrap',
    address: '0xee17d5bF4B19a0df17B07dd47078e5F04a02ecFa',
  },
  advisors: {
    fullName: 'Advisory',
    address: '0xe10c92b4C637A5968350B483816BBafa826bfA6C',
  },
  partnerships: {
    fullName: 'Strategic partners',
    address: '0xBD7496dE773C0289aa1aAe6F6FdcE62dD63EcAa8',
  },
  burned: {
    fullName: 'Burned',
    address: '0x886C0867eF6d37F5c48cc13FAF3a888652a99361',
  },
}
